<svg width="100%" height="100%" viewBox="0 0 200 200" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <circle r="80" cx="100" cy="100" fill="transparent" stroke-dasharray="502.6548245743669" stroke-dashoffset="0"></circle>
    <circle class="bar" r="80" cx="100" cy="100" fill="transparent" stroke-dasharray="502.6548245743669" [ngStyle]="{'stroke-dashoffset': strockDashOffset}"></circle>
</svg>
